import { Link } from "react-router-dom";
import { PageHero } from "../components/ui";
import { NAV } from "../data/site";

export default function Sitemap() {
    const company = NAV.find((n) => n.children)?.children || [];
    return (
        <>
            <PageHero eyebrow="Legal — Sitemap" lines={["Every page,", "one place."]} trail={[{ label: "Home", path: "/" }, { label: "Sitemap" }]} />
            <section className="bg-paper">
                <div className="container-x grid gap-12 py-20 sm:py-24 sm:grid-cols-2 lg:grid-cols-3 lg:py-28">
                    <div className="border-t-2 border-ink pt-6">
                        <p className="eyebrow mb-6">Main</p>
                        <ul className="space-y-3">
                            {NAV.filter((n) => !n.children).map((n) => (
                                <li key={n.path}>
                                    <Link to={n.path} className="font-display text-lg font-semibold text-ink transition-colors hover:text-blue">{n.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="border-t-2 border-ink pt-6">
                        <p className="eyebrow mb-6">Company</p>
                        <ul className="space-y-3">
                            {company.map((c) => (
                                <li key={c.path}>
                                    <Link to={c.path} className="font-display text-lg font-semibold text-ink transition-colors hover:text-blue">{c.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="border-t-2 border-ink pt-6">
                        <p className="eyebrow mb-6">Projects & Legal</p>
                        <ul className="space-y-3">
                            {[
                                { label: "Germany — Ahaus CAES", path: "/projects/germany-ahaus-caes" },
                                { label: "Germany — BESS", path: "/projects/germany-bess" },
                                { label: "Denmark — Green Hydrogen Hub CAES", path: "/projects/denmark-green-hydrogen-hub-caes" },
                                { label: "Denmark — BESS", path: "/projects/denmark-bess" },
                                { label: "Privacy Policy", path: "/privacy" },
                                { label: "Cookie Policy", path: "/cookies" },
                                { label: "Terms of Use", path: "/terms" },
                            ].map((l) => (
                                <li key={l.path}>
                                    <Link to={l.path} className="font-display text-lg font-semibold text-ink transition-colors hover:text-blue">{l.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
        </>
    );
}
